const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the integrations collection  component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('integrationsCollection', ['Application', 'Authorization', 'CompanyIntegrations', 'ContentIntegrations', 'Companies', '$translate', function (Application, Authorization, CompanyIntegrations, ContentIntegrations, Companies, $translate) {
  return {
    restrict: 'E',
    template: require('../../templates/directives/integrations-collection.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      var params = Application.navigation.getUrlParameters();
      self.codePresent = params.code && params.code !== 'null';
      self.company = Authorization.getAuthToken().company;
      self.flags = Application.features.flags();
      self.samlType = '';
      self.microsoftTeamsVersion = Application.microsoftTeamsVersion;
      self.changeIndex = function($event, level, type) {
        self.currentItem = type;

        if (type === 'saml') {
          self.samlType = self.integrationStates.oneLogin === 'configured' ? 'OneLogin' : self.integrationStates.okta === 'configured' ? 'Okta' : 'SAML';
        }

        //prevent default
        if ($event) {
          $event.preventDefault();
        }

        // set options for index level
        self.viewIndex = -100/2 * level + '%';

        // scroll top
        document.querySelector('#collection-menu').scrollIntoView(true);
      };

      self.modalactive = false;

      self.translateHTML = function(key){
        var value = $translate.instant(key, null, null, null, 'sanitize');
        return value;
      };

      // States: available|unavailable|configured
      self.integrationStates = {
        googleAnalytics: self.company.google_analytics ? 'configured' : 'available',
        googleDrive: self.company.google_drive ? 'configured' : 'available',
        googleCalendar: 'configured',
        scorm: self.company.scorm ? 'configured' : 'available',
        recording: self.flags.webrecording ? 'configured' : 'available',
        video_assessments: self.flags.video_assessments ? 'configured' : 'available',
        youtube: 'configured',
        vimeo: 'configured',
        salesforce: 'available',
        slack: self.company.slack ? 'available' : 'unavailable',
        slackEddy: self.company.slack && self.flags.enable_knowledgebase_ai_eddy_assistant ? 'available' : 'unavailable',
        teams: self.flags.enable_microsoft_teams_messaging ? 'available' : 'unavailable',
        okta: 'available',
        oneLogin: 'available',
        saml: 'available',
        oracle: 'available',
        paylocity: 'available',
        ecommerce: self.flags.ecommerce,
        stripe: self.flags.ecommerce ? 'available' : 'unavailable',
        workday: 'available',
        zoom: self.flags.zoom ? 'available' : 'unavailable',
        bamboo: self.company.bamboo ? 'available' : 'unavailable',
        udemy: self.company.udemy ? 'available' : 'unavailable',
        linkedin_learning: self.company.linkedin_learning ? 'available' : 'unavailable',
        masterclass: self.flags.enable_masterclass ? 'available' : 'unavailable',
      };

      CompanyIntegrations.status({}, function (data) {
        var companyIntegration = data || {};
        self.integrationStates.slack = companyIntegration.slack ? 'configured' : self.integrationStates.slack;
        self.integrationStates.zoom = companyIntegration.zoom && self.flags.zoom ? 'configured' : self.integrationStates.zoom;
        self.integrationStates.stripe = companyIntegration.stripe ? 'configured' : self.integrationStates.stripe;
        if (
          companyIntegration.microsoftTeamsMessaging?.version &&
          companyIntegration.microsoftTeamsMessaging.version === self.microsoftTeamsVersion
        ) {
          self.integrationStates.teams = 'configured';
        } else if (
          companyIntegration.microsoftTeamsMessaging &&
          companyIntegration.microsoftTeamsMessaging.version
        ) {
          self.integrationStates.teams = 'outdated';
        }
        if (companyIntegration.eddySlack) {
          self.integrationStates.slackEddy = 'configured';
        }

        if (companyIntegration.bamboo && companyIntegration.bamboo.subdomain && companyIntegration.bamboo.apikey) {
          self.integrationStates.bamboo = 'configured';
        }

        if (self.flags.zoom && params && params.integration && params.integration === 'zoom') {
          setTimeout(function() {
            self.changeIndex(null, 1, 'zoom');
            $scope.$apply();
          }, 1000);
        }

        if (Application.storage.get('eddySlackBannerClicked')) {
          setTimeout(function() {
            self.changeIndex(null, 1, 'slack-eddy');

            Application.storage.remove('eddySlackBannerClicked');
            $scope.$apply();
          }, 100);
        }
      }, function (error) {
        console.log('Error occured getting company integration ', error);
      });

      ContentIntegrations.existing().$promise
      .then(function(results) {
        if (!results || !results.integrations || !results.integrations.length) {
          return;
        }
        results.integrations.forEach(function(item) {
          if (self.integrationStates[item] === 'available') {
            self.integrationStates[item] = 'configured';
          }
        });
      });

      var host = Application.companyDomain;
      Companies.checkAlternativeLogins({domain: host, authtoken: 'public'}).$promise
      .then(function(results) {
        // also returns type for use with LDAP down the line
        if (!results.use_options && results.link && results.link.length > 6) {
          // if (results.link.toLowerCase().indexOf('onelogin') !== -1) {
          //   self.integrationStates.oneLogin = 'configured';
          //   self.integrationStates.okta = 'unavailable';
          //   self.integrationStates.saml = 'unavailable';
          //   return;
          // }
          // if (results.link.toLowerCase().indexOf('okta') !== -1) {
          //   self.integrationStates.oneLogin = 'unavailable';
          //   self.integrationStates.okta = 'configured';
          //   self.integrationStates.saml = 'unavailable';
          //   return;
          // }
          // self.integrationStates.oneLogin = 'unavailable';
          // self.integrationStates.okta = 'unavailable';
          self.integrationStates.saml = 'configured';
        }
        if (results.use_options) {
          // self.integrationStates.oneLogin = 'unavailable';
          // self.integrationStates.okta = 'unavailable';
          self.integrationStates.saml = 'configured';
        }
      }).catch(function(error) {
        console.log('error: ', error);
      });

    }],
    controllerAs: 'integrations'
  };
}]);
